import _classCallCheck from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { CONTEXT_STORE } from '../globals';
export var createMinimalBaseAudioContextConstructor = function createMinimalBaseAudioContextConstructor(audioDestinationNodeConstructor, createAudioListener, eventTargetConstructor, isNativeOfflineAudioContext, unrenderedAudioWorkletNodeStore, wrapEventListener) {
  return /*#__PURE__*/function (_eventTargetConstruct) {
    _inherits(MinimalBaseAudioContext, _eventTargetConstruct);

    var _super = _createSuper(MinimalBaseAudioContext);

    function MinimalBaseAudioContext(_nativeContext, numberOfChannels) {
      var _this;

      _classCallCheck(this, MinimalBaseAudioContext);

      _this = _super.call(this, _nativeContext);
      _this._nativeContext = _nativeContext;
      CONTEXT_STORE.set(_assertThisInitialized(_this), _nativeContext); // Bug #93: Edge will set the sampleRate of an AudioContext to zero when it is closed.

      var sampleRate = _nativeContext.sampleRate;
      Object.defineProperty(_nativeContext, 'sampleRate', {
        get: function get() {
          return sampleRate;
        }
      });

      if (isNativeOfflineAudioContext(_nativeContext)) {
        unrenderedAudioWorkletNodeStore.set(_nativeContext, new Set());
      }

      _this._destination = new audioDestinationNodeConstructor(_assertThisInitialized(_this), numberOfChannels);
      _this._listener = createAudioListener(_assertThisInitialized(_this), _nativeContext);
      _this._onstatechange = null;
      return _this;
    }

    _createClass(MinimalBaseAudioContext, [{
      key: "currentTime",
      get: function get() {
        return this._nativeContext.currentTime;
      }
    }, {
      key: "destination",
      get: function get() {
        return this._destination;
      }
    }, {
      key: "listener",
      get: function get() {
        return this._listener;
      }
    }, {
      key: "onstatechange",
      get: function get() {
        return this._onstatechange;
      },
      set: function set(value) {
        var wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
        this._nativeContext.onstatechange = wrappedListener;
        var nativeOnStateChange = this._nativeContext.onstatechange;
        this._onstatechange = nativeOnStateChange !== null && nativeOnStateChange === wrappedListener ? value : nativeOnStateChange;
      }
    }, {
      key: "sampleRate",
      get: function get() {
        return this._nativeContext.sampleRate;
      }
    }, {
      key: "state",
      get: function get() {
        return this._nativeContext.state;
      }
    }]);

    return MinimalBaseAudioContext;
  }(eventTargetConstructor);
};